/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{getDefaultUnitForView as t}from"../support/getDefaultUnitForView.js";const e={readOnly:!0,get(){return t(this.view)}};export{e as defaultUnitPropertyMetadata};
